<template>
  <div class="wrapper">
    <div class="open_navbar" @click="toggleNavBar">
      <i class="fal fa-bars"></i>
    </div>
    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel">
      <!-- <top-navbar></top-navbar> -->
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <div class="close_navBar" @click="toggleNavBar"></div>
      <!-- <content-footer></content-footer> -->
    </div>
    <div id="main_account_chat" :data-chatconnect="chat_key"></div>

    <div v-if="returnAdminToken" @click="returnToAdmin" class="backToAdmin">
      <span class="backToAdminLabel">Вернуться в админку</span>
      <i class="backToAdminIcon fal fa-arrow-circle-right"></i>
    </div>
    <stop />
  </div>
</template>
<style lang="stylus">
.backToAdmin {
  background: white;
  position: fixed;
  top: 15px;
  right: 20px;
  height: 50px;
  width: 165px;
  z-index: 2;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  cursor: pointer;

  .backToAdminIcon {
    position: relative;
    left: 10px;
    top: 0px;
    font-size: 16px;
  }

  .backToAdminLabel {
    padding: 3px 8px;
    display: block;
    font-size: 10pt;
  }

  &:hover {
    color: #3f51b5;
  }
}

.open_navbar {
  display: none;
}

.main-panel {
  min-height: 100vh;

  .close_navBar {
    display: none;
  }
}

@media only screen and (max-width: 700px) {
  .open_navbar {
    display: block;
    position: fixed;
    top: 14px;
    left: 16px;
    z-index: 1;
    font-size: 30px;
    background: #ffffffb5;
    padding: 0 10px;
    border-radius: 6px;
    color: #005eb1;
  }

  .nav-open {
    .main-panel {
      .close_navBar {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        z-index: 5;
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .backToAdmin {
    background: #3f51b5;
    color: white;

    &:hover {
      background: #4f63d5;
      color: white;
    }
  }

  .open_navbar {
    background: rgb(14, 14, 14);
    color: #939393;
  }
}
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import UserMenu from "src/components/UIComponents/SidebarPlugin/UserMenu.vue";

import stop from "../../Stop.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    UserMenu,
    stop
  },
  data() {
    return {
      chat_key: "",
      returnAdminToken: "",
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleNavBar() {
      if (window.document.body.classList.contains("nav-open")) {
        window.document.body.classList.remove("nav-open");
      } else {
        window.document.body.classList.add("nav-open");
      }
    },
    returnToAdmin() {
      localStorage.token = this.returnAdminToken;
      localStorage.returnAdminToken = "";
      document.location.href = "/admin/users";
    },
  },
  mounted() {
    let franchise = this.$store.state.userData.franchise;
    this.chat_key = franchise.chat_key;
    this.returnAdminToken = localStorage.returnAdminToken;
  },
};
</script>
